import React, { useState } from 'react';
import Hero from '../components/Hero';
import { Box} from '@mui/material';
import HomeCard from '../components/HomeCard';
import HomeVideo from '../components/HomeVideo';
import Slider from '../components/Slider';
import ImageAnimation from '../components/imageanimaton';
import Navbar from '../components/Navbar'; // Import your Navbar
import SEO from '../components/SEO'; // Import SEO Component
import LocalBusinessSchema from '../components/LocalBusinessSchema'; // Import Local Business Schema
// Footer is not imported anymore, since we are removing it
// import Footer from '../components/Footer';

const Home = () => {
  const [darkMode, setDarkMode] = useState(false);

  return (
    <>
      {/* SEO Meta Tags for Home Page - Optimized for "near me" searches */}
      <SEO 
        title="Wedding Lighting Services Western Province | Event Lighting Colombo | Miracle Lighting Sri Lanka"
        description="Professional wedding lighting services in Western Province and event lighting services in Colombo, Gampaha, Kalutara. Best wedding lighting company in Sri Lanka providing LED lights, decorative lighting, outdoor & indoor lighting for weddings, events, parties. වෙස්ටර්න් ප්‍රොවින්ස් විවාහ ආලෝක සේවා | කොළඹ උත්සව ආලෝක සේවා"
        keywords="wedding lighting services Western Province, event lighting services Colombo, wedding lighting Sri Lanka, event lighting Western Province, light decoration services Sri Lanka, miracle lighting Sri Lanka, මිරකල් ලයිටින් ශ්‍රී ලංකා, event lighting near me Sri Lanka, lighting decoration Colombo, lighting decoration Western Province, best wedding lighting company Colombo, කොළඹ හොඳම විවාහ ලයිටින් සමාගම, lighting for weddings Sri Lanka, party lighting services Western Province, වෙස්ටර්න් ප්‍රොවින්ස් පාටි ලයිටින් සේවා, wedding reception lighting Colombo, professional lighting services Sri Lanka, outdoor wedding lighting Sri Lanka, western province wedding lighting, වෙස්ටර්න් ප්‍රොවින්ස් විවාහ ආලෝක සේවා, Colombo event lighting & decoration, කොළඹ උත්සව ලයිටින් සහ සැරසිලි, Gampaha lighting services, ගම්පහ ලයිටින් සේවා, Kalutara event lights & decoration, කළුතර උත්සව ලයිට් සහ සැරසිලි, lighting setup for weddings Sri Lanka, ශ්‍රී ලංකාවේ විවාහ සඳහා ලයිට් සෙටප්, led lights near me, string lights near me, miracle lighting, wedding lights, event lighting, decorative lights, Christmas lights, Kathina festival lighting, Vesak decorations, party lights, temple lighting, outdoor lighting, indoor lighting, Colombo, Gampaha, Kandy, Kalutara, Negombo, Sri Lanka"
        url="https://miraclelighting.lk"
      />

      {/* Local Business Structured Data - Critical for local SEO */}
      <LocalBusinessSchema />

      {/* Navbar Section */}
      <Navbar toggleDarkMode={() => setDarkMode(prev => !prev)} darkMode={darkMode} />


      {/* Main Container */}
      <Box
        sx={{
          backgroundColor: darkMode ? '#000' : '#FFF', // Set background color based on darkMode
          color: darkMode ? '#FFF' : '#000', // Set text color for better readability
          minHeight: '100vh', // Ensure the box covers the full height of the viewport
        }}
      >
        {/* Hero Section */}
        <Hero />

        {/* Video and Right Side Content Section */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            py: 10,
            px: 4,
            flexWrap: 'wrap', // Ensure responsiveness on smaller screens
          }}
        >
          <HomeVideo darkMode={darkMode} /> {/* Pass the darkMode state */}
        </Box>

        <div>
          <Slider /> {/* Add the Slider component here */}
        </div>

        {/* Right Side Carousel */}
        <Box sx={{ width: '100%', py: 6 }}>
          <ImageAnimation darkMode={darkMode} /> {/* Pass darkMode prop */}
        </Box>

        {/* Services Section */}
        <HomeCard darkMode={darkMode} /> {/* Pass the darkMode state */}

      </Box>
    </>
  );
};

export default Home;
